import { render, staticRenderFns } from "./sendmessageframe.vue?vue&type=template&id=5edf732c&"
import script from "./sendmessageframe.vue?vue&type=script&lang=js&"
export * from "./sendmessageframe.vue?vue&type=script&lang=js&"
import style0 from "./sendmessageframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports